var SHOPANALYZER_PERF_ENDPOINT =
  "https://cellmetics-analyzer.vercel.app/api/track-perf";

var shopAnalyzerFcpObserver = null;
var shopAnalyzerLcpObserver = null;
var shopAnalyzerLcpValue = null;
var shopAnalyzerOriginalFetch = window.fetch;
var shopAnalyzerOriginalXhrOpen = XMLHttpRequest.prototype.open;
var shopAnalyzerOriginalXhrSend = XMLHttpRequest.prototype.send;

function shopAnalyzerGetClientId() {
  try {
    var key = "shopanalyzer_perf_client_id";
    var id = localStorage.getItem(key);
    if (!id) {
      id =
        window.crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : "perf-" + Date.now() + "-" + Math.random().toString(16).slice(2);
      localStorage.setItem(key, id);
    }
    return id;
  } catch (e) {
    return "unknown";
  }
}

function shopAnalyzerSendPerf(metric, valueMs) {
  try {
    fetch(SHOPANALYZER_PERF_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({
        metric: metric,
        value: Math.round(valueMs),
        clientId: shopAnalyzerGetClientId(),
        timestamp: new Date().toISOString(),
        path: window.location.pathname,
      }),
      keepalive: true,
    });
  } catch (e) {
    // never let tracking break the storefront
  }
}

function shopAnalyzerHandleFcpEntries(list) {
  var entries = list.getEntries();
  for (var i = 0; i < entries.length; i++) {
    if (entries[i].name === "first-contentful-paint") {
      shopAnalyzerSendPerf("fcp", entries[i].startTime);
      shopAnalyzerFcpObserver.disconnect();
    }
  }
}

function shopAnalyzerInitFcpTracking() {
  try {
    shopAnalyzerFcpObserver = new PerformanceObserver(
      shopAnalyzerHandleFcpEntries,
    );
    shopAnalyzerFcpObserver.observe({ type: "paint", buffered: true });
  } catch (e) {}
}

function shopAnalyzerHandleLcpEntries(list) {
  var entries = list.getEntries();
  var last = entries[entries.length - 1];
  if (last) shopAnalyzerLcpValue = last.startTime;
}

function shopAnalyzerFinalizeLcp() {
  if (document.visibilityState === "hidden" && shopAnalyzerLcpValue !== null) {
    shopAnalyzerSendPerf("lcp", shopAnalyzerLcpValue);
    shopAnalyzerLcpObserver.disconnect();
    shopAnalyzerLcpValue = null;
  }
}

function shopAnalyzerInitLcpTracking() {
  try {
    shopAnalyzerLcpObserver = new PerformanceObserver(
      shopAnalyzerHandleLcpEntries,
    );
    shopAnalyzerLcpObserver.observe({
      type: "largest-contentful-paint",
      buffered: true,
    });
    document.addEventListener("visibilitychange", shopAnalyzerFinalizeLcp);
    addEventListener("pagehide", shopAnalyzerFinalizeLcp);
  } catch (e) {}
}

function shopAnalyzerPatchedFetch(input, init) {
  var url = typeof input === "string" ? input : (input && input.url) || "";
  if (url.indexOf("/cart/add") === -1)
    return shopAnalyzerOriginalFetch.apply(this, arguments);
  var start = performance.now();
  return shopAnalyzerOriginalFetch.apply(this, arguments).then(
    function (res) {
      shopAnalyzerSendPerf("add_to_cart_latency", performance.now() - start);
      return res;
    },
    function (err) {
      shopAnalyzerSendPerf("add_to_cart_latency", performance.now() - start);
      throw err;
    },
  );
}

function shopAnalyzerInitFetchTracking() {
  try {
    window.fetch = shopAnalyzerPatchedFetch;
  } catch (e) {}
}

function shopAnalyzerPatchedXhrOpen(method, url) {
  this._shopAnalyzerIsCartAdd =
    typeof url === "string" && url.indexOf("/cart/add") !== -1;
  return shopAnalyzerOriginalXhrOpen.apply(this, arguments);
}

function shopAnalyzerHandleXhrLoadEnd(startTime) {
  shopAnalyzerSendPerf("add_to_cart_latency", performance.now() - startTime);
}

function shopAnalyzerPatchedXhrSend() {
  if (this._shopAnalyzerIsCartAdd) {
    var start = performance.now();
    this.addEventListener("loadend", function () {
      shopAnalyzerHandleXhrLoadEnd(start);
    });
  }
  return shopAnalyzerOriginalXhrSend.apply(this, arguments);
}

function shopAnalyzerInitXhrTracking() {
  try {
    XMLHttpRequest.prototype.open = shopAnalyzerPatchedXhrOpen;
    XMLHttpRequest.prototype.send = shopAnalyzerPatchedXhrSend;
  } catch (e) {}
}

shopAnalyzerInitFcpTracking();
shopAnalyzerInitLcpTracking();
shopAnalyzerInitFetchTracking();
shopAnalyzerInitXhrTracking();
